import React from 'react';
import TextField from '@mui/material/TextField';

export const TextFieldCustom = (props) => {
    return <TextField {...props} size="small" fullWidth />;
};
